import {Drawer, Stack, Toolbar} from "@mui/material";
import {AiDrawerState} from "../atoms";
import {useAtom} from "jotai";
import ChatWindow from "../../survey-designer/ChatWindow";

export const aiDrawerWidth = "500px"

export const AiDrawer = () => {
  const [open, setOpen] = useAtom(AiDrawerState);

  const handleClose = () => setOpen(false);

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      disableEnforceFocus={true}
      sx={{
        position: "fixed",
        maxWidth: aiDrawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          maxWidth: aiDrawerWidth,
          width: "100%",
          boxSizing: 'border-box',
          zIndex: 4, px: 0, pb: 2,
        },
      }}
      variant="persistent"
      anchor="right"
    >
      <Stack direction={"column"} justifyContent={"space-between"} sx={{height: '100%'}}>
        <Toolbar />
        <ChatWindow />
      </Stack>
    </Drawer>
  )
}